/**
 * Quick Calculator Trigger Button
 *
 * TopBar icon button that opens the Quick License Plate Calculator.
 * Matches the styling of other TopBar buttons (theme, notepad, etc.)
 */

import { Calculator } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useQuickCalculator } from '../QuickCalculatorContext';

export function QuickCalculatorTrigger() {
  const { t } = useTranslation('common');
  const { open } = useQuickCalculator();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={open}
            aria-label={t('calculator.trigger', 'Snelle calculator')}
            className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-border hover:bg-muted transition-colors"
          >
            <Calculator size={18} />
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t('calculator.trigger', 'Snelle calculator')}</p>
          <p className="text-xs text-muted-foreground">⌘L</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
